import { Navigate, useParams } from 'react-router';
import { fleetRecordPath, type FleetTab } from '../fleet.paths';

/** Old record URLs (`/fleet/:id`, `/trailers/:id`, `/owners/:id`) from before records moved under their Fleet tab — shared links keep working. */
export function RedirectToFleetRecord({ tab }: { tab: FleetTab }) {
  const { id = '' } = useParams();
  return <Navigate to={fleetRecordPath(tab, id)} replace />;
}
